import React from 'react';
import { InputNumber } from 'antd';
import { useFormikContext } from 'formik';
import { FormFieldWrapper } from './FormFieldWrapper';
import { FieldInfoMessage } from './FieldInfoMessage';

export const NumberField = (props: any) => {
  const { name, label, disabled, placeholder, infoMessage, required } = props;
  const { handleBlur, setFieldValue, values } = useFormikContext<any>();

  const handleChange = (value: number | null) => {
    // Ensure only valid numbers are set
    const isValidNumber = value !== null && !isNaN(value) && /^[0-9]*$/.test(String(value));
    if (isValidNumber) {
      setFieldValue(name, value);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent typing non-numeric characters
    if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      event.preventDefault();
    }
  };

  return (
    <FormFieldWrapper name={name} label={label} required={required}>
      <InputNumber
        name={name}
        value={values[name] || null} // Ensure value is a number or null
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown} // Restrict input at keydown level
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        style={{ width: '100%' }}
        controls={!disabled} // Show controls only if not disabled
      />
      {infoMessage && <FieldInfoMessage message={infoMessage} />}
    </FormFieldWrapper>
  );
};